import React from "react";
import styles from "@src/components/organisms/organizations-view-admin-panel/organizations-view-admin-panel.module.scss";
import OrganizationsTableAdminPanel from "@src/components/organisms/organizations-table-admin-panel/organizations-table-admin-panel";
import useOrganizationsViewAdminPanelHook from "@src/components/organisms/organizations-view-admin-panel/use-organizations-view-admin-panel-hook";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import { FlexColumnContainer } from "@src/components/templates/layouts/flex-column-container/flex-column-container";
import { CrossNameSpaceOrganziation } from "@src/types/namespace-configuration";

const cssClassName = "organizations-view-admin-panel";

interface OrganizationsViewAdminPanelProps {
  isLoadingOrganizations: boolean;
  organizations: CrossNameSpaceOrganziation[];
}

const OrganizationsViewAdminPanel = ({
  isLoadingOrganizations,
  organizations,
}: OrganizationsViewAdminPanelProps) => {
  const { texts } = useOrganizationsViewAdminPanelHook();

  return (
    <FlexColumnContainer>
      <FlexRowContainer justifyContent="space-between">
        <p className={styles[`${cssClassName}__title`]}>{texts.title}</p>
      </FlexRowContainer>
      <p className={styles[`${cssClassName}__description`]}>
        {texts.description}
      </p>
      <OrganizationsTableAdminPanel
        isLoading={isLoadingOrganizations}
        organizations={organizations}
      />
    </FlexColumnContainer>
  );
};

export default OrganizationsViewAdminPanel;
